define('rebrush/components/gigaset_customprint/legal',[
    'jquery',
    'lodash',
    'cartware/components/_base',
    'cartware/jquery/bem',
    'gigaset/spinner',
    'text!shoptheme/templates/magnific-popup/default.html',
    'magnific-popup'
], function(
    $,
    _,
    Component,
    BEM,
    Spinner,
    PopupHtml
) {
    return Component.create({
        $init: function () {
            let productViewBlock = BEM.block('product-view'),
                productAddToCartBlock = BEM.block('product-detail-add-to-cart'),
                container = productViewBlock.getElements('column-technical'),
                addToCart = productAddToCartBlock.getElements('add-to-cart-button'),
                optionInputs = container.find('input[data-show-legal-popup="true"]'),
                legalInput = $(productAddToCartForm.form).find('input[name="legal_accepted"]'),
                popupTemplate = null;

            const legalPopupOpenClass = 'print-legal-popup-open';

            if (legalInput.length < 1) {
                return;
            }

            function _sendRequest(url, data, onSuccessCallback) {
                var data = data || {};

                // add isAjax param to avoid caching problems
                if (url.indexOf('isAjax=1') === -1 && typeof data === 'string' && data.indexOf('isAjax=1') === -1) {
                    url += url.indexOf('?') === -1 ? '?isAjax=1' : '&isAjax=1';
                }

                url = (this.isSecure === true && url.indexOf('http://') === 0) ? url.replace('http://', 'https://') : url;

                $.ajax(url, {
                    method: 'POST',
                    data: data
                }).then(_.bind(function (response, status, xhr) {
                    if (response.success) {
                        if (typeof onSuccessCallback === 'function') {
                            onSuccessCallback(response, status, xhr);
                        }
                    }
                }, this));
            }

            let defaultAddToCartFunc = addToCart.prop('onclick');
            addToCart.prop('onclick', null);

            function callbackLegalPopup() {
                $(document).on('click', '.' + BEM.buildElementClassname('print-legal-popup', 'add-to-cart-btn'), _.bind(function(e) {
                    let inlineValidateNotice = $('.' + BEM.buildElementClassname('print-legal-popup', 'print-validate-error')),
                        inlineTermsCheckbox = $('.' + BEM.buildElementClassname('print-legal-popup', 'print-terms-checkbox'));

                    legalInput.val(0);

                    inlineValidateNotice.hide();

                    if (!inlineTermsCheckbox.prop('checked')) {
                        e.preventDefault();
                        inlineValidateNotice.show();

                        return false;
                    }

                    legalInput.val(1);


                    $.magnificPopup.close();
                    defaultAddToCartFunc();
                }, this));
            }

            function _renderPopup(data) {
                if (null === popupTemplate) {
                    popupTemplate = _.template(PopupHtml);
                }

                return popupTemplate(data);
            }

            function _showPopup(message, openCallBack) {

                $.magnificPopup.open({
                    closeOnContentClick: false,
                    closeOnBgClick: false,
                    closeBtnInside: true,
                    items: [
                        {
                            src: _renderPopup({ body: message }),
                            type: 'inline'
                        }
                    ],
                    callbacks: {
                        open: function() {
                            if (typeof openCallBack === 'function') {
                                openCallBack();
                            }
                        }
                    }
                });
            }

            function initLegalPopup() {
                var legalPopupUrl = optionInputs.data('legal-popup-url');

                Spinner.add();

                _sendRequest(legalPopupUrl, null, _.bind(function(response, status, xhr) {

                    _showPopup(response.success, _.bind(callbackLegalPopup, this));

                    $.magnificPopup.instance.wrap.addClass(legalPopupOpenClass);
                    $.magnificPopup.instance.bgOverlay.addClass(legalPopupOpenClass);

                    Spinner.remove();
                }, this));
            }

            function waitForElm(selector) {
                return new Promise(resolve => {
                    if (document.querySelector(selector)) {
                        return resolve(document.querySelector(selector));
                    }

                    const observer = new MutationObserver(mutations => {
                        if (document.querySelector(selector)) {
                            resolve(document.querySelector(selector));
                            observer.disconnect();
                        }
                    });

                    observer.observe(document.body, {
                        childList: true,
                        subtree: true
                    });
                });
            }

            addToCart.on('click', function (e) {
                let showLegal = false;

                if (!optionInputs.length || e.currentTarget.getAttribute('data-customprint-added') !== '1') {
                    // skip if on engraving has been added
                    defaultAddToCartFunc();
                } else {
                    // category lightbox
                    if($.magnificPopup.instance.isOpen) {

                        initLegalPopup.call($.magnificPopup.instance);

                        var legalPopup = '.' + BEM.buildElementClassname('print-legal-popup', 'container');

                        waitForElm(legalPopup).then((elm) => {
                            callbackLegalPopup();
                        });
                    }

                    // product detail page
                    optionInputs.each(function () {
                        if ($(this).val()) {
                            initLegalPopup();
                            showLegal = true;
                            return false;
                        }
                    });

                    if (!showLegal) {
                        defaultAddToCartFunc();
                    }
                }
            });
        },
    });
});
